import script from "./diamondsSearchFormSimple.vue?vue&type=script&setup=true&lang=ts"
export * from "./diamondsSearchFormSimple.vue?vue&type=script&setup=true&lang=ts"

import "./diamondsSearchFormSimple.vue?vue&type=style&index=0&id=5b566f48&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b566f48"]])

export default __exports__